import React from "react";
import { Snackbar, Alert, AlertColor, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export interface ToastProps {
  open: boolean;
  message: string;
  type?: AlertColor; // Utilisé par ToastContainer (compatibilité)
  severity?: AlertColor; // Alias pour type
  duration?: number;
  onClose: () => void;
}

/**
 * Composant Toast pour afficher des notifications
 * Utilise Material-UI Snackbar et Alert
 */
export const Toast: React.FC<ToastProps> = ({
  open,
  message,
  type,
  severity,
  duration = 4000,
  onClose,
}) => {
  // Utiliser type ou severity (compatibilité avec ToastContainer)
  const alertSeverity = type || severity || "info";
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{
        "& .MuiSnackbarContent-root": {
          borderRadius: 2,
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={alertSeverity}
        variant="filled"
        sx={{
          width: "100%",
          borderRadius: 2,
          "& .MuiAlert-icon": {
            fontSize: 20,
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
            sx={{ ml: 1 }}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
